import { Controller } from "@hotwired/stimulus"

// Быстрые пресеты периода для фильтра сводного отчёта.
// Кнопка (data-range="…") задаёт Дата с / Дата по и сразу отправляет форму (GET).
//
// Пишем и в скрытые ISO-поля (name=date_from/date_to — уходят на сервер),
// и в видимые display-инпуты datepicker-а (dd.mm.yyyy) — чтобы до перезагрузки
// страницы не мелькали старые даты. Контроллер вешается на сам <form>.
export default class extends Controller {
  apply(event) {
    event.preventDefault()
    const [from, to] = this.range(event.currentTarget.dataset.range)
    this.setDate("date_from", from)
    this.setDate("date_to", to)
    this.element.requestSubmit()
  }

  range(key) {
    const today = startOfDay(new Date())
    switch (key) {
      case "today":
        return [today, today]
      case "week":
        return [startOfWeek(today), today]
      case "month":
        return [startOfMonth(today), today]
      case "prev_month":
        return [
          new Date(today.getFullYear(), today.getMonth() - 1, 1),
          new Date(today.getFullYear(), today.getMonth(), 0)
        ]
      case "last7":
        return [addDays(today, -6), today]
      case "last30":
        return [addDays(today, -29), today]
      default:
        return [today, today]
    }
  }

  setDate(name, date) {
    const value = this.element.querySelector(`input[type="hidden"][name="${name}"]`)
    if (value) value.value = toISO(date)
    const display = value?.closest(".input-group")?.querySelector("[data-datepicker-target='display']")
    if (display) display.value = toDisplay(date)
  }
}

function startOfDay(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate())
}

function startOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1)
}

// Начало недели — понедельник (как в datepicker: weekStart 1).
function startOfWeek(d) {
  const day = d.getDay() // 0 — воскресенье
  return addDays(d, -(day === 0 ? 6 : day - 1))
}

function addDays(d, n) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate() + n)
}

// Локальная дата → "yyyy-mm-dd" без сдвига TZ (toISOString даёт UTC).
function toISO(d) {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

function toDisplay(d) {
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`
}

function pad(n) {
  return String(n).padStart(2, "0")
}
